import {Component, Input, OnInit} from '@angular/core';
import {WorkFlowStepClass} from '../../models/workflow-step/workflow-step-base.model';
import {WorkflowDetailClientService} from '../dialog/workflow-detail-dialog/workflow-detail-client.service';
import {faFileImport, faTriangleExclamation} from '@fortawesome/free-solid-svg-icons';
import {WorkflowStep} from '../../enums/WorkflowStep';
import {Workflow} from '../../enums/Workflow';
import {filter} from 'rxjs';
import {PlateMode} from '../../enums/PlateMode';
import {WorkflowInstanceStepGlomaxService} from "../../services/workflow-instance-step-glomax.service";

@Component({
  selector: 'app-workflow-step-common',
  templateUrl: './workflow-step-common.component.html',
  styleUrls: ['./workflow-step-common.component.scss']
})
export class WorkflowStepCommonComponent implements OnInit {
  WorkFlowStepClass = WorkFlowStepClass;
  Workflow = Workflow;
  WorkflowStep = WorkflowStep;
  PlateMode = PlateMode;
  faFileImport = faFileImport;
  faTriangleExclamation = faTriangleExclamation;

  @Input() readOnly: boolean = false;

  isStepSkipped = false;

  constructor(public workflowDetailClientService: WorkflowDetailClientService,
              private workflowInstanceStepGlomaxService: WorkflowInstanceStepGlomaxService) {
  }

  ngOnInit(): void {
    this.workflowDetailClientService.selectedStep$.pipe(filter(v => !!v)).subscribe((v) => {
      this.workflowDetailClientService.isStepValid$.next(false);
      this.isStepSkipped = v.isSkipped;
    });
   this.workflowDetailClientService.initPlatePlaceholders();
  }

  switchPlateViewDnaExtractionSwabLysis() {
    this.workflowDetailClientService.fetchWorkflowInstanceStepByStep(WorkflowStep.DNA_EXTRACTION_SWAB_LYSIS);
  }

  switchPlateViewToCalculation() {
    this.workflowDetailClientService.fetchWorkflowInstanceStepByStep(WorkflowStep.NORMALIZATION_PREPARATION);
  }

  isGlomaxStepPending(): boolean {
    const currentStep = this.workflowDetailClientService.workflowInstance?.currentStep;
    return !this.workflowDetailClientService.selectedStep$.getValue() &&
      (currentStep === WorkflowStep.MEASUREMENT_GLOMAX_FIRST || currentStep === WorkflowStep.MEASUREMENT_GLOMAX_SECOND);
  }

  onGlomaxFileAdded(fileList: FileList) {
    const currentStep = this.workflowDetailClientService.workflowInstance?.currentStep;
    const workflowInstanceId = this.workflowDetailClientService.workflowInstance?.id;

    if (currentStep && workflowInstanceId) {
      this.workflowInstanceStepGlomaxService.manuallyAddFileByWorkflowInstanceId(workflowInstanceId, currentStep, fileList)
        .subscribe(resp => {
          this.workflowDetailClientService.selectedStep$.next(resp);
          // Also trigger refresh of workflow instance to update the current step if needed
          this.workflowDetailClientService.fetchWorkInstanceStep();
        });
    }
  }

}
